import { alpha } from '@mui/system/colorManipulator';
import { error, info, neutral, success, warning } from '../colors';
import { getPrimary } from '../utils';

export const createPalette = (config) => {
  const { colorPreset, contrast } = config;

  const primary = getPrimary(colorPreset);

  const darkPrimary = {
    ...primary,
    lightest: '#0A2245',
    light: '#3E6AC1',
    main: '#4E7CD8',
    dark: '#7BA0E4',
    darkest: '#A9C3F0',
  };

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[100], 0.38),
      disabledBackground: alpha(neutral[100], 0.12),
      focus: alpha(neutral[100], 0.16),
      hover: alpha(neutral[100], 0.04),
      selected: alpha(neutral[100], 0.12),
    },
    background: {
      default: contrast === 'high' ? '#060E1A' : '#0A1628',
      paper: '#111D32',
    },
    divider: '#1E3A5C',
    error,
    info,
    mode: 'dark',
    neutral,
    primary: colorPreset === 'garante' || colorPreset === 'blue' ? darkPrimary : primary,
    success,
    text: {
      primary: '#EDF2F7',
      secondary: '#A0AEC0',
      disabled: 'rgba(255, 255, 255, 0.48)',
    },
    warning,
  };
};
